/*
  « Acheter maintenant » : ajoute le produit au panier, puis ouvre le paiement.

  On lit le formulaire du produit tel quel (format choisi, quantité, options),
  donc rien à tenir à jour quand le visiteur change de format. Si l'ajout
  échoue (rupture de stock, quantité trop grande), on laisse le bouton
  « Ajouter au panier » du thème soumettre le formulaire : c'est lui qui
  affiche le message d'erreur.
*/
(() => {
  if (window.cblAcheter) return;
  window.cblAcheter = true;

  const racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  document.addEventListener('click', async (e) => {
    const bouton = e.target.closest('[data-cbl-acheter]');
    if (!bouton || bouton.getAttribute('aria-busy')) return;
    const formulaire = bouton.closest('form');
    if (!formulaire) return;
    const ajouter = formulaire.querySelector('[name="add"]');
    if (ajouter && ajouter.disabled) return;

    bouton.setAttribute('aria-busy', 'true');
    try {
      const reponse = await fetch(`${racine}cart/add.js`, {
        method: 'POST',
        body: new FormData(formulaire),
        headers: { Accept: 'application/json' },
      });
      if (!reponse.ok) throw new Error(String(reponse.status));
      location.href = `${racine}checkout`;
    } catch {
      bouton.removeAttribute('aria-busy');
      if (ajouter && formulaire.requestSubmit) formulaire.requestSubmit(ajouter);
    }
  });
})();
